import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../assets/images/kesariyalogo.webp";
import { MdArrowRightAlt, MdOutlineEmail } from "react-icons/md";
import { IoLocationOutline } from "react-icons/io5";
import { BsTelephone } from "react-icons/bs";
import googleplay from "../../assets/images/image 681 (1).webp";
import image1 from "../../assets/images/image 1.webp";
import image2 from "../../assets/images/image 2.webp";
import image3 from "../../assets/images/image 3.webp";
import image4 from "../../assets/images/image 4.webp";
import image5 from "../../assets/images/image 5.webp";
import image6 from "../../assets/images/image 6.webp";
import image7 from "../../assets/images/image 7.webp";
import image8 from "../../assets/images/image 8.webp";
import image9 from "../../assets/images/image 9.webp";
import image10 from "../../assets/images/image 10.webp";
import { RiInstagramLine } from "react-icons/ri";
import { FaYoutube, FaFacebook, FaPinterest } from "react-icons/fa";
import { saveAs } from "file-saver";
import { RiTwitterXFill } from "react-icons/ri";
import { ImMail3 } from "react-icons/im";
import { Tooltip } from "react-tooltip";
import { ADDRESS_API, EMAIL_API, FOOTER_API, PHONE_API } from "../../config/config";
import { Button } from "react-bootstrap";
import axios from "axios";
export const Footer = () => {
  const images = [
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
    image8,
    image9,
    image10,
  ];

  const [data, setData] = useState();
  const [socialIcons, setSocialIcons] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchFooterData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(FOOTER_API);
      console.log("footer Api:", response.data);
      if (response.data.footer) {
        setData(response.data.footer);
      }

      if (response.data?.social_icons) {
        setSocialIcons(response.data.social_icons);
      }
      else {
        console.error("Unexpected API response structure:", response.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const downloadPDF = () => {
    const pdfUrl = `${data?.brochure_file}`;
    saveAs(pdfUrl, "dd12-13_0.pdf");
  };

  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/about");
  };

  useEffect(() => {
    fetchFooterData();
  }, [])

  return (
    <div className="footer">
      <div className="container">
        <footer>
          <div className="row row-cols-1 row-cols-md-5 row-cols-sm-2 pt-3 them-font">
            <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
              <a
                href="/"
                className="d-flex align-items-center text-decoration-none link-body-emphasis mb-3 mt-0"
              >
                <img
                  src={data?.footer_image}
                  alt="Kesaria Textile Company"
                  className="img-fluid"
                />
              </a>
              <p style={{ textAlign: "justify", fontSize: "15px" }} className="responsive-font-footer">
                {data?.footer_description}
              </p>

              <button
                className="btn btn-black-to-red-color-move btn-dark rounded-5"
                onClick={handleNavigate}
              >
                <span className="responsive-font-footer">Know More</span>
                <span>
                  <MdArrowRightAlt />
                </span>
              </button>
            </div>
            <div className="col-6 col-lg-2 col-md-4 company my-3">
              <div className="fs-4 fw-bold responsive-font-footer">Company</div>
              <ul className="flex-column nav" style={{ fontSize: "16px" }}>
                <li className="nav-item mb-2 responsive-font-footer">
                  <Link to="/" className="nav-link p-0 text-dark">
                    Home
                  </Link>
                </li>
                <li className="nav-item mb-2 responsive-font-footer">
                  <Link to="/blog/" className="nav-link p-0 text-dark">
                    Blogs
                  </Link>
                </li>
                <li className="nav-item mb-2 responsive-font-footer">
                  <Link to="/career/" className="nav-link p-0 text-dark">
                    Careers
                  </Link>
                </li>
                <li className="nav-item mb-2 responsive-font-footer">
                  <Link to="/market-area/" className="nav-link p-0 text-dark">
                    Market Area
                  </Link>
                </li>
                <li className="nav-item mb-2 responsive-font-footer">
                  <Link
                    to="/customer-review/"
                    className="nav-link p-0 text-dark"
                  >
                    Customer Review
                  </Link>
                </li>
                <li className="nav-item mb-2 responsive-font-footer">
                  <Link
                    to="/track-your-delivery/"
                    className="nav-link p-0 text-dark"
                  >
                    Track Your delivery
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-6 col-lg-2 my-3 responsive-font-footer">
              <div className="fs-4 fw-bold responsive-font-footer">Customer Service</div>
              <ul className="flex-column nav" style={{ fontSize: "16px" }}>
                <li className="nav-item mb-2 responsive-font-footer">
                  <Link to="/enquiry-ktc/" className="nav-link p-0 text-dark">
                    Enquire Now
                  </Link>
                </li>
                <li className="nav-item mb-2 responsive-font-footer">
                  <Link
                    to="/privacy-policy-2/"
                    className="nav-link p-0 text-dark"
                  >
                    Privacy Policy
                  </Link>
                </li>
                <li className="nav-item mb-2 responsive-font-footer">
                  <Link
                    to="terms-condition/"
                    className="nav-link p-0 text-dark"
                  >
                    Terms & Conditions
                  </Link>
                </li>
                <li className="nav-item mb-2 responsive-font-footer">
                  <Link to="/return-policy/" className="nav-link p-0 text-dark">
                    Return & Exchange
                  </Link>
                </li>
                <li className="nav-item mb-2 responsive-font-footer">
                  <Link to="/contact-us/" className="nav-link p-0 text-dark">
                    Contact Us
                  </Link>
                </li>
                <li className="nav-item mb-2 responsive-font-footer">
                  <Link to="/faq/" className="nav-link p-0 text-dark">
                    FAQ
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-3 col-md-6 my-3">
              <h3 className="fs-4 fw-bold responsive-font-footer">Contact With Us</h3>
              <ul className="flex-column nav" style={{ fontSize: "16px" }}>
                <li className="d-flex nav-item mb-2 footer-info-text">
                  <IoLocationOutline className="fs-2 me-2" />
                  <div className="responsive-font-footer">
                    {/* B 3031-32, Millennium Textile Market-1, Ring Road, Surat,
                    Gujarat 395002 */}
                    {data?.footer_address}
                  </div>
                </li>
                <li className="nav-item mb-2 footer-info-text responsive-font-footer">
                  <BsTelephone className="me-2" />
                  {/* Phone: +91 9876543210 */}
                  {/* Phone: +91-9909048061 */}
                  Phone: {data?.footer_phone}
                </li>
                <li className="nav-item mb-2 footer-info-text responsive-font-footer">
                  <MdOutlineEmail className="me-2" />
                  Email:{" "}
                  <a
                    // href="mailto:info@kesaria.com"
                    href="mailto:info.kesaria@kesariatextile.com"
                    className="text-dark text-decoration-none"
                  >
                    {/* info@kesaria.com */}
                    {/* info.kesaria@kesariatextile.com */}
                    {data?.footer_email}
                  </a>
                </li>
              </ul>
              <div className="ms-4 responsive-font-footer">
                Follow us on:
                {/* <div className="d-flex flex-row gap-2 mt-2 ">
                  <Link to="http://www.youtube.com/@KesariaTextileCompany">
                    <FaYoutube
                      className="text-danger icon-hover"
                      style={{ fontSize: "20px" }}
                      data-tooltip-id="social-tooltip"
                      data-tooltip-content="YouTube"
                    />
                  </Link>
                  <Link to="https://x.com/KesariaTextile">
                    <RiTwitterXFill
                      className="text-dark icon-hover"
                      style={{ fontSize: "20px" }}
                      data-tooltip-id="social-tooltip"
                      data-tooltip-content="Twitter"
                    />
                  </Link>
                  <Link to="https://www.facebook.com/kesariatextileco/">
                    <FaFacebook
                      style={{ color: "#1773ea", fontSize: "20px" }}
                      className="icon-hover"
                      data-tooltip-id="social-tooltip"
                      data-tooltip-content="Facebook"
                    />
                  </Link>
                  <Link to="https://in.pinterest.com/KesariaTextileCo/">
                    <FaPinterest
                      style={{ color: "#e60023", fontSize: "20px" }}
                      className="icon-hover"
                      data-tooltip-id="social-tooltip"
                      data-tooltip-content="Pinterest"
                    />
                  </Link>
                  <Link to="mailto:info.kesaria@kesariatextile.com">
                    <ImMail3
                      style={{ color: "#1c93f6", fontSize: "19px" }}
                      className="icon-hover"
                      data-tooltip-id="social-tooltip"
                      data-tooltip-content="Email"
                    />
                  </Link>
                  <Link to="https://www.instagram.com/kesariatextileco/">
                    <RiInstagramLine
                      className="gradient-icon icon-hover"
                      style={{ color: ":#405DE6", fontSize: "20px" }}
                      data-tooltip-id="social-tooltip"
                      data-tooltip-content="Instagram"
                    />
                  </Link>
                </div> */}
                <div className="d-flex flex-row gap-2 mt-2">
                  {socialIcons.map((icon, index) => (
                    <a key={index} href={icon.icon_link} target="_blank" rel="noopener noreferrer">
                      <img
                        src={icon.icon_image}
                        alt={icon.icon_name || "social"}
                        className="icon-hover"
                        data-tooltip-id="social-tooltip"
                        data-tooltip-content={icon.alt}
                      />
                    </a>
                  ))}
                </div>

              </div>
              <Tooltip id="social-tooltip" place="bottom" effect="solid" />
            </div>
            <div className="col-lg-2 col-md-6 col-sm-12 d-flex flex-column align-items-center googleplay my-3">
              <img src={googleplay} alt="Google Play" className="google-play-btn img-fluid" />
              <button
                className="btn-red-to-black-color-move brochurebtn mt-md-2"
                onClick={downloadPDF}
              >
                <span className="view-brochure-res">{data?.view_brochure}</span>
              </button>
            </div>
          </div>
          <div className="d-flex flex-wrap row justify-content-center footercompanyimg">
            <div className="col-12 d-flex flex-wrap justify-content-center footer-images1">
              {images.map((e, i) => (
                <img
                  key={i}
                  src={e}
                  alt={`image ${i + 1}`}
                  className="bg-white m-1 p-2 rounded-2 footer-images icon-hover img-fluid"
                  style={{ width: "60px" }}
                />
              ))}
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};
